var poll_default = {
  "fontElementMap": "wp3bV",
  "container": "UAWSJ",
  "fullscreen": "_3wmLg",
  "background_overlay": "V2TlL",
  "with_image": "mqj40",
  "options": "qmkPl",
  "webview": "UrInZ",
  "grid": "TLOlp",
  "option": "_-0W0k",
  "cta_button": "NAWHR",
  "add_option": "Ji7SQ",
  "see_more": "gb-O0",
  "list": "BohwW",
  "column": "jtinW",
  "additional_note": "_8HJfm",
  "spinner": "SthDS",
  "spin": "Vts-X",
  "shown": "RYE4P",
  "error": "gPWc-"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
